var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6505 17.6547V17.654H17.6549V11.179C17.6549 8.01136 16.973 5.57129 13.2699 5.57129C11.4896 5.57129 10.295 6.5482 9.80727 7.47436H9.75577V5.86701H6.24463V17.654H9.90069V11.8175C9.90069 10.2808 10.192 8.79481 12.0951 8.79481C13.9702 8.79481 13.9981 10.5485 13.9981 11.9161V17.6547H17.6505Z",
    fill: "#111748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.29126 5.86816H3.95174V17.6551H0.29126V5.86816Z",
    fill: "#111748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.12007 0C0.949693 0 0 0.949694 0 2.12008C0 3.29046 0.949693 4.26001 2.12007 4.26001C3.29046 4.26001 4.24015 3.29046 4.24015 2.12008C4.23941 0.949694 3.28972 0 2.12007 0V0Z",
    fill: "#111748"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.cca9dbdf700cbeb65c13a4d5c45d95d9.svg";
export { ForwardRef as ReactComponent };